module.exports = __webpack_public_path__ + "img/italy.a90643db.svg";